export const INIT_SUBSCRIPTIONS_FORM = 'INIT_SUBSCRIPTIONS_FORM';
export const INIT_SUBSCRIPTIONS_FORM_ERROR = 'INIT_SUBSCRIPTIONS_FORM_ERROR';
export const INIT_SUBSCRIPTIONS_FORM_SUCCESS = 'INIT_SUBSCRIPTIONS_FORM_SUCCESS';

export const SUBMIT_SUBSCRIPTIONS_FORM = 'SUBMIT_SUBSCRIPTIONS_FORM';
export const SUBMIT_SUBSCRIPTIONS_FORM_ERROR = 'SUBMIT_SUBSCRIPTIONS_FORM_ERROR';
export const SUBMIT_SUBSCRIPTIONS_FORM_SUCCESS = 'SUBMIT_SUBSCRIPTIONS_FORM_SUCCESS';

export const RESET_SUBSCRIPTIONS_STATE = 'RESET_SUBSCRIPTIONS_STATE';
